import { render, staticRenderFns } from "./LanguageImport.vue?vue&type=template&id=ea7fa536&scoped=true&"
import script from "./LanguageImport.vue?vue&type=script&lang=js&"
export * from "./LanguageImport.vue?vue&type=script&lang=js&"
import style0 from "./LanguageImport.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LanguageImport.vue?vue&type=style&index=1&id=ea7fa536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea7fa536",
  null
  
)

export default component.exports